import { Component, OnInit, Renderer2 } from "@angular/core";
import { MatDialog } from "@angular/material/dialog";
import { environment } from "src/environments/environment";

@Component({
    selector: "website-loading",
    templateUrl: "./loading.component.html",
    styleUrls: ["./loading.component.css"],
})
export class LoadingComponent implements OnInit {
    logoPath = `assets/images/${environment.logo}`;

    constructor(
        private dialog: MatDialog,
        private renderer: Renderer2 
    ) {}

    ngOnInit(): void {}

    openDialogLoading(loading: boolean): void {
        if (loading) {
            const dialogRef = this.dialog.open(LoadingComponent, {
                disableClose: true,
                panelClass: "custom-dialog",
                data: {},
            });

            dialogRef.afterOpened().subscribe(() => {
                // Estilos adicionales opcionales
                const elements = document.querySelectorAll(".mat-mdc-dialog-surface, .mdc-dialog__surface");
                elements.forEach((element: Element) => {
                    this.renderer.setStyle(element, "background-color", "#e6e6e61a"); // Fondo transparente
                    this.renderer.setStyle(element, "backdrop-filter", "blur(15px)"); // Fondo transparente
                    this.renderer.addClass(element, "fullBlur")
                });
            });
        } else {
            this.dialog.closeAll();
        }
    }
}
